import React from 'react';
import {
  PhotoIcon,
  FilmIcon,
  MusicalNoteIcon,
  DocumentTextIcon,
  TableCellsIcon,
  PresentationChartBarIcon,
  ArchiveBoxIcon,
  DocumentIcon,
} from '@heroicons/react/24/outline';

/** 依檔案類型顯示單色圖示（§3-4：不用 emoji 當圖示） */
const iconFor = (mimeType: string) => {
  if (mimeType.startsWith('image/')) return PhotoIcon;
  if (mimeType.startsWith('video/')) return FilmIcon;
  if (mimeType.startsWith('audio/')) return MusicalNoteIcon;
  if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) return TableCellsIcon;
  if (mimeType.includes('powerpoint') || mimeType.includes('presentation')) return PresentationChartBarIcon;
  if (mimeType === 'application/pdf' || mimeType.includes('word') || mimeType.includes('document')) return DocumentTextIcon;
  if (mimeType.includes('zip') || mimeType.includes('rar') || mimeType.includes('7z')) return ArchiveBoxIcon;
  return DocumentIcon;
};

const FileTypeIcon: React.FC<{ mimeType: string; className?: string }> = ({ mimeType, className = 'h-6 w-6' }) => {
  const Icon = iconFor(mimeType);
  return <Icon className={`${className} text-fg-secondary`} aria-hidden="true" />;
};

export default FileTypeIcon;
